/**
 * @fileoverview Резолв дружелюбных названий полей по структуре fetcher-schema
 * @description Разрешает title по позиции в схеме (с учётом locale), а не по плоскому ключу
 */

const ARRAY_INDEX_KEY = /^\[\d+\]$/;

function isKazakh(locale) {
  return locale === "kk" || locale === "kz";
}

/**
 * Возвращает локализованное название поля из узла схемы
 * @param {Object} properties - properties текущего уровня схемы
 * @param {string} key - ключ поля
 * @param {string} locale - локаль (ru | kk)
 * @returns {string} title или сам key как fallback
 */
export function resolveTitle(properties, key, locale = "ru") {
  const node = properties?.[key];
  if (!node) return key;

  if (isKazakh(locale)) {
    return node.title_kz || node.title || node.title_ru || key;
  }
  return node.title_ru || node.title || key;
}

/**
 * Возвращает properties для children указанного узла данных
 * @param {Object} properties - properties текущего уровня схемы
 * @param {Object} dataNode - узел из flattenToStructuredList
 * @returns {Object|undefined} properties следующего уровня
 */
export function descendSchema(properties, dataNode) {
  if (!properties || !dataNode) return undefined;

  if (ARRAY_INDEX_KEY.test(String(dataNode.key || ""))) {
    return properties;
  }

  const child = properties[dataNode.key];
  if (!child) return undefined;

  if (child.type === "array" || child.items) {
    return child.items?.properties;
  }
  if (child.properties) {
    return child.properties;
  }
  return undefined;
}
